import { MyApi } from '@/service/api';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';

export interface UserType {
  active: {
    htmlUrl: string;
    imageUrl: string;
    status: string;
  } | null;
  user: {
    g_user_id: string;
    nick_name: string;
    mobile: string;
    will_expire_cards_count: number; //即将到期优惠券数量
  } | null;
}

export interface ModelType {
  namespace: string;
  state: UserType;
  effects: {
    fetch: Effect;
  };
  reducers: {
    save: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'user',

  state: {
    user: null,
    active: null,
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      const response = yield call(MyApi);
      if (callback) callback();
      yield put({
        type: 'save',
        payload: response,
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        user: payload.data.user || null,
        active: payload.data.active || null,
      };
    },
  },
};

export default Model;
